import React, { useState, lazy, Suspense } from 'react'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import Contact from './pages/Contact'
import Disclaimer from './pages/Disclaimer'
import Acknowledgement from './pages/Acknowledgement'
import Footer from './components/Footer'
import Navbar from './components/Navbar'
import AlertMessage from './components/AlertMessage'
import Preloader from './components/Preloader'

const Dashboard = lazy(() => import("./pages/Dashboard"))

const App = () => {
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  return (
    <Router>
      <Navbar />
      {alertMessage && <AlertMessage text={alertMessage} showAlert={showAlert}
        setShowAlert={setShowAlert} />}
      <Suspense fallback={<Preloader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/map" element={<Dashboard setAlertMessage={setAlertMessage} setShowAlert={setShowAlert} />} />

          <Route path="/contact" element={<Contact />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/acknowledgement" element={<Acknowledgement />} />
        </Routes>
      </Suspense>
      <Footer />
    </Router>
  )
}

export default App